import React from 'react';
import PropTypes from 'prop-types';
import { fetchImgAsBase64, isBase64 } from '@Utils/Network';

export default class ImageBase64 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      src: '',
    };
  }

  render () {
    return this.props.children(this.state);
  }

  componentDidUpdate(prevProps) {
    if (this.props.src === prevProps.src) {
      return;
    }

    this.getImage();
  }

  componentDidMount() {
    this.getImage();
  }

  async getImage () {
    const { src, getImageAsync } = this.props;

    if (!src) {
      return;
    }

    if(isBase64(src)){
      this.setState({
        src,
      });
      return;
    }

    const result = await getImageAsync(src);

    if (this.unmounted) {
      return;
    }

    this.setState({
      src: result
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }
}

ImageBase64.defaultProps = {
  getImageAsync: fetchImgAsBase64,
};

ImageBase64.propTypes = {
  children: PropTypes.func.isRequired,
  getImageAsync: PropTypes.func,
  src: PropTypes.string.isRequired,
};
